import React, { Component } from 'react';
import {
    Alert, Row, Col

} from 'reactstrap';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import CompanyContext from '../../auth/CompanyContext';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

class DemographicsGraph extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);
        this.state = {
            loading: true,
            data: this.props.data != null ? this.props.data : null,
            labels: [],
            debug_message: null,
            columns: this.props.columns != null ? this.props.columns : 1
        };

    }

    graphStyles = {
        fill: false,
        lineTension: 0.1,
        borderCapStyle: 'butt',
        borderJoinStyle: 'miter',
        pointBorderWidth: 1,
        pointRadius: 2,
        pointHoverRadius: 5,
        pointHitRadius: 10,
    };

    colors = ['#005c1e', '#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600'];

    data = {
        'AUM Total': {
            ...this.graphStyles,
            label: 'AUM Total',
            borderColor: this.colors[0],
            backgroundColor: this.colors[0],
            pointBorderColor: this.colors[0],
            data: []
        },
        'HNW AUM': {
            ...this.graphStyles,
            label: 'HNW AUM',
            borderColor: this.colors[1],
            backgroundColor: this.colors[1],
            pointBorderColor: this.colors[1],
            data: []
        },
        'Individual AUM': {
            ...this.graphStyles,
            label: 'Individual AUM',
            borderColor: this.colors[2],
            backgroundColor: this.colors[2],
            pointBorderColor: this.colors[2],
            data: []
        },
        'Pension AUM': {
            ...this.graphStyles,
            label: 'Pension AUM',
            borderColor: this.colors[3],
            backgroundColor: this.colors[3],
            pointBorderColor: this.colors[3],
            data: []
        },
        'Non-Discretionary AUM': {
            ...this.graphStyles,
            label: 'Non-Discretionary AUM',
            borderColor: this.colors[4],
            backgroundColor: this.colors[4],
            pointBorderColor: this.colors[4],
            data: []
        },
        'Discretionary AUM': {
            ...this.graphStyles,
            label: 'Discretionary AUM',
            borderColor: this.colors[5],
            backgroundColor: this.colors[5],
            pointBorderColor: this.colors[5],
            data: []
        },
        'Total Accounts': {
            ...this.graphStyles,
            label: 'Total Accounts',
            borderColor: this.colors[0],
            backgroundColor: this.colors[0],
            pointBorderColor: this.colors[0],
            data: []
        },
        'HNW Accounts': {
            ...this.graphStyles,
            label: 'HNW Accounts',
            borderColor: this.colors[1],
            backgroundColor: this.colors[1],
            pointBorderColor: this.colors[1],
            data: []
        },
        'Individual Accounts': {
            ...this.graphStyles,
            label: 'Individual Accounts',
            borderColor: this.colors[2],
            backgroundColor: this.colors[2],
            pointBorderColor: this.colors[2],
            data: []
        },
        'Pension Accounts': {
            ...this.graphStyles,
            label: 'Pension Accounts',
            borderColor: this.colors[3],
            backgroundColor: this.colors[3],
            pointBorderColor: this.colors[3],
            data: []
        },
        'Non-Discretionary Accounts': {
            ...this.graphStyles,
            label: 'Non-Descretionary Accounts',
            borderColor: this.colors[4],
            backgroundColor: this.colors[4],
            pointBorderColor: this.colors[4],
            data: []
        },
        'Discretionary Accounts': {
            ...this.graphStyles,
            label: 'Discretionary Accounts',
            borderColor: this.colors[5],
            backgroundColor: this.colors[5],
            pointBorderColor: this.colors[5],
            data: []
        },
    };
    labels = [];

    componentDidMount() {
        this.setState(
            { loading: true },
            () => { this.state.data?.length > 0 ? this.setDisplayData(this.state.data) : this.getDemographicsGraphData(); }
        );

    }

    getDemographicsGraphData() {
        let URL = '/api/demographicsGraph/' + this.props.secID;
        fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.data.length > 0) {
                    this.props.changeDateRange([...results.data].map(item => item.Dataset));
                    this.setDisplayData(results.data);
                }
                this.setState({ loading: false })
            });
        return;
    }

    setDisplayData = (data) => {
        data.forEach(row => {
            this.data['AUM Total'].data.push(row['AUM Total'] !== null ? row['AUM Total'] : 0);
            this.data['HNW AUM'].data.push(row['HNW AUM'] !== null ? row['HNW AUM'] : 0);
            this.data['Individual AUM'].data.push(row['Individual AUM'] !== null ? row['Individual AUM'] : 0);
            this.data['Pension AUM'].data.push(row['Pension AUM'] !== null ? row['Pension AUM'] : 0);
            this.data['Non-Discretionary AUM'].data.push(row['Non-Discretionary AUM'] !== null ? row['Non-Discretionary AUM'] : 0);
            this.data['Discretionary AUM'].data.push(row['Discretionary AUM'] !== null ? row['Discretionary AUM'] : 0);
            this.data['Total Accounts'].data.push(row['Total Accounts'] !== null ? row['Total Accounts'] : 0);
            this.data['HNW Accounts'].data.push(row['HNW Accounts'] !== null ? row['HNW Accounts'] : 0);
            this.data['Individual Accounts'].data.push(row['Individual Accounts'] !== null ? row['Individual Accounts'] : 0);
            this.data['Pension Accounts'].data.push(row['Pension Accounts'] !== null ? row['Pension Accounts'] : 0);
            this.data['Non-Discretionary Accounts'].data.push(row['Non-Discretionary Accounts'] !== null ? row['Non-Discretionary Accounts'] : 0);
            this.data['Discretionary Accounts'].data.push(row['Discretionary Accounts'] !== null ? row['Discretionary Accounts'] : 0);
            this.labels.push(row['Month'] + '/' + row['Year']);
        });

        this.setState({
            loading: false,
            data: this.data,
        });
    }


    render() {
        const totalSum = this.state.data ? Object.values(this.state.data)
            .flatMap(obj => obj.data)
            .reduce((sum, num) => sum + num, 0) : null;

        if (!this.state.loading && (!this.state.data || totalSum === 0)) return (<>No graph data available</>);
        if (this.state.loading === true || typeof (this.state.data) === 'undefined') {
            return (
                <><Alert color="info">
                    Loading graphs - please be patient, this may take a minute...
                </Alert></>
            )
        } else {
            //return (<></>)

            const AUMdata = {
                labels: this.labels,
                datasets: [
                    this.state.data['AUM Total'],
                    this.state.data['HNW AUM'],
                    this.state.data['Individual AUM'],
                    this.state.data['Pension AUM'],
                    this.state.data['Non-Discretionary AUM'],
                    this.state.data['Discretionary AUM'],
                ]
            };
            const AUMoptions = {
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            callback: (value) => {
                                const s = value.toString().split(/(?=(?:...)*$)/).join(',');
                                return '$' + s;
                            }
                        }
                    }
                }
            };
            const accountsOptions = {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            };
            if ('scaleAxesAUM' in this.props) {
                AUMoptions.scales.y.suggestedMax =
                    this.props.scaleAxesAUM ?? Math.max(...[...this.props.data].map(i => i['AUM Total']));
                accountsOptions.scales.y.suggestedMax =
                    this.props.scaleAxesAccounts ?? Math.max(...[...this.props.data].map(i => i['Total Accounts']));
            }

            const accountsData = {
                labels: this.labels,
                datasets: [
                    this.state.data['Total Accounts'],
                    this.state.data['HNW Accounts'],
                    this.state.data['Individual Accounts'],
                    this.state.data['Pension Accounts'],
                    this.state.data['Non-Discretionary Accounts'],
                    this.state.data['Discretionary Accounts'],
                ]
            };
            return (
                <Row>
                    <Col md={12 / this.state.columns}>
                        <h4>AUM</h4>
                        <Line data={AUMdata} options={AUMoptions} height={300} />
                    </Col>
                    <Col md={12 / this.state.columns}>
                        <h4>Accounts</h4>
                        <Line data={accountsData} options={accountsOptions} height={300} />
                    </Col>
                </Row>
            )
        }
    }
}



export default DemographicsGraph;
